import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { designTokens } from "@cinch-labs/design-system";
import { HeartIcon, SVG_GRADIENT_IDS as GRADIENT_IDS } from "@cinch-nx/shared-ui";
import cx from "classnames";
import styles from "./save-button.module.css";
export var SAVE_CAR = "Save car to your profile";
export var UNSAVE_CAR = "Remove car from saved list";
var gradientFill = "url(#".concat(GRADIENT_IDS.alpha, ")");
var SVGHeart = HeartIcon;
export var SaveButton = function(param) {
    var onClick = param.onClick, isSaved = param.isSaved, size = param.size, className = param.className, children = param.children, _isPending = param.isPending, isPending = _isPending === void 0 ? false : _isPending;
    var classNames = cx([
        styles.button,
        className
    ], _define_property({}, styles.loading, isPending));
    var padding = designTokens.customProperties.ds.font.size["3xs"];
    var height = Number.parseInt(size, 10) + Number.parseInt(padding, 10);
    return /*#__PURE__*/ _jsxs("button", {
        style: {
            borderRadius: height * 0.5,
            visibility: isPending ? "hidden" : "visible"
        },
        className: classNames,
        disabled: isPending,
        title: isSaved ? UNSAVE_CAR : SAVE_CAR,
        type: "button",
        onClick: function(e) {
            e.stopPropagation();
            onClick();
        },
        children: [
            /*#__PURE__*/ _jsx(SVGHeart, {
                role: "presentation",
                height: size,
                width: size,
                style: {
                    display: "inline-flex",
                    width: size,
                    height: size,
                    fill: isSaved && !isPending ? gradientFill : "none",
                    stroke: !isPending ? gradientFill : "none",
                    strokeWidth: isPending ? 0 : 2.5
                }
            }),
            children
        ]
    });
};
